export default "__VITE_ASSET__CJn11nBl__"